import { isEmpty } from 'lodash'
const required = (value) => (value ? undefined : 'Campo requerido')
const numeric = (value) => {
  return value && !/^[0-9]+$/.test(value)
    ? 'El campo debe ser numerico.'
    : undefined
}

const patente = (value) => {
  value = value
    .toUpperCase()
    .split(' ')
    .join('')
  const patents = [
    { pattern: /^[A-Z]{3}\d{3}$/ },
    { pattern: /^\d{3}[A-Z]{3}$/ },
    { pattern: /^[A-Z]{2}\d{3}[A-Z]{2}$/ },
    { pattern: /^[A-Z]{1}\d{3}[A-Z]{3}$/ }
  ]

  const result = patents.filter((el) => el.pattern.test(value))

  return result.length === 0 ? 'La patente es invalida' : undefined
}

const cuit = (value) => {
  var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
  var total = 0
  var cuit = []

  value = value ? value.toString().replace(/-/g, '') : ''

  if (value.match(/[a-z]/i)) {
    return 'El cuit tiene un formato inválido'
  }

  for (var x = 0; x < value.length; x++) {
    if (value.substr(x, 1) !== '') {
      cuit[x] = value.substr(x, 1)
    }
  }

  if (cuit.length == 0) return undefined

  if (cuit.length == 11) {
    var prim = cuit[0] + cuit[1]
    if (
      prim == 27 ||
      prim == 20 ||
      prim == 23 ||
      prim == 30 ||
      prim == 33 ||
      prim == 34 ||
      prim == 24
    ) {
      for (var i = 0; i < mult.length; i++) {
        total += parseInt(cuit[i]) * mult[i]
      }
      var mod = total % 11
      var digito = mod == 0 ? 0 : mod == 1 ? 9 : 11 - mod

      if (digito == parseInt(cuit[10])) {
        return undefined
      } else {
        return 'El cuit tiene un formato inválido'
      }
    } else {
      return 'El cuit tiene un formato inválido'
    }
  } else {
    return 'El cuit tiene un formato inválido'
  }
}

const validDni = (value) => {
  if (isEmpty(value)) return 'Campo requerido'

  if (String(value.length) < 7) return 'Dni mayor 7'

  if (String(value.length) > 8) return 'Dni menor 8'

  return undefined
}

const validChasis = (value) => {
  if (isEmpty(value)) return 'Campo requerido'

  if (value.length !== 7) {
    return 'debe colocar 7 caracteres'
  } else {
    return undefined
  }
}

const maxLength = (max) => (value) =>
  value && value.length > max
    ? `Debe tener menos de ${max} caracteres`
    : undefined
const maxLength15 = maxLength(15)
const maxLength13 = maxLength(13)
const maxLength22 = maxLength(22)
const maxLength4 = maxLength(4)
const maxLength7 = maxLength(7)
const minLength = (min) => (value) => {
  return value && value.length < min
    ? `Debe tener ${min} cararteres o mas`
    : undefined
}
const minLength8 = minLength(8)
const minLength11 = minLength(11)
const minLength22 = minLength(22)
const minLength3 = minLength(3)
const minLength5 = minLength(5)
const minLength7 = minLength(7)
const email = (value) =>
  value && !/^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'E-mail invalido'
    : undefined
const alphaNumeric = (value) =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Solo caracteres alfanumericos'
    : undefined
const alpha = (value) =>
  value && !/^[a-zA-Z]+$/.test(value)
    ? 'No se permiten caracteres numericos'
    : undefined
const isSame = (value, allValues) => {
  if (allValues.password) {
    return value !== allValues.password && 'Las contraseñas no coinciden.'
  }
}

const isNotSame = (value, allValues) => {
  if (allValues.password) {
    return (
      value === allValues.old_password &&
      'Tu contraseña nueva no puede ser igual a la actual.'
    )
  }
}

const monthDay = (value) => {
  return value && (value < 1 || value > 31)
    ? 'Ingresar un nº de día (Entre 1 y 31)'
    : undefined
}

const isBetween = (n, a, b) => {
  return (n - a) * (n - b) <= 0
}

export { validDni }
export { isBetween }
export { isNotSame }
export { monthDay }
export { required }
export { numeric }
export { maxLength }
export { maxLength7 }
export { maxLength4 }
export { maxLength13 }
export { maxLength15 }
export { maxLength22 }
export { minLength22 }
export { minLength }
export { minLength5 }
export { minLength11 }
export { minLength3 }
export { minLength7 }
export { minLength8 }
export { email }
export { alphaNumeric }
export { alpha }
export { isSame }
export { patente }
export { cuit }
export { validChasis }
